import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class AddShootingRequest implements ISerialize {
    public Bib: number;

    public ContestantId: number;

    public Lane: number;

    public RaceContestantId: number;

    public ShootingNumber: number;

    public Shots: number[];

    public Time: Date;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Bib?: number;
        ContestantId?: number;
        Lane?: number;
        RaceContestantId?: number;
        ShootingNumber?: number;
        Shots?: number[];
        Time?: Date;
    }) {
        this.Bib = values.Bib ?? 0;

        this.ContestantId = values.ContestantId ?? 0;

        this.Lane = values.Lane ?? 0;

        this.RaceContestantId = values.RaceContestantId ?? 0;

        this.ShootingNumber = values.ShootingNumber ?? 0;

        this.Shots = values.Shots ?? [];

        this.Time = values.Time ?? new Date('1970-01-01T00:00:00.000');
    }

    public serialize(): string {
        return (
            '{' +
            `"Bib": ${JSON.stringify(this.Bib)}` +
            ',' +
            `"ContestantId": ${JSON.stringify(this.ContestantId)}` +
            ',' +
            `"Lane": ${JSON.stringify(this.Lane)}` +
            ',' +
            `"RaceContestantId": ${JSON.stringify(this.RaceContestantId)}` +
            ',' +
            `"ShootingNumber": ${JSON.stringify(this.ShootingNumber)}` +
            ',' +
            `"Shots": [ ${this.Shots.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"Time": ${'"' + formatDateIso(this.Time) + '"'}` +
            '}'
        );
    }

    /**
     * Creates an instance of AddShootingRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Bib?: number;
        ContestantId?: number;
        Lane?: number;
        RaceContestantId?: number;
        ShootingNumber?: number;
        Shots?: number[];
        Time?: Date;
    }): AddShootingRequest {
        return new AddShootingRequest(values);
    }

    public static _FromServerJson(json: any): AddShootingRequest {
        return new AddShootingRequest({
            Bib: json.Bib,
            ContestantId: json.ContestantId,
            Lane: json.Lane,
            RaceContestantId: json.RaceContestantId,
            ShootingNumber: json.ShootingNumber,
            Shots: json.Shots,
            Time: json.Time instanceof Date ? json.Time : new Date(json.Time),
        });
    }

    /**
     * Creates an instance of AddShootingRequest from another instance of AddShootingRequest.
     * @param other The AddShootingRequest you want to clone
     * @returns A cloned AddShootingRequest
     */
    public static FromOther(other: AddShootingRequest): AddShootingRequest {
        return AddShootingRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return AddShootingRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'AddShootingRequest';
}
